import { createSlice, createAsyncThunk, current } from '@reduxjs/toolkit';
import {
  GetDirectoDataAndAnalyticsData,
  GetDirectorAnalysisData,
  GetDDLEthnicityData,
  GetDDLAppointmentTypeData,
} from '../../../utils/toolDirectorDataAndAnalytics-utils';
import { NUMBER_TWO, NUMBER_ONE } from '../../../constants/NumberConstants';

const APPOINTMENT_DATA_ROW_LIMIT = 50000;

export const getDirectoDataAndAnalyticsDataReq = createAsyncThunk('getDirectoDataAndAnalyticsDataReq', async (req) => {
  const response = await GetDirectoDataAndAnalyticsData(req);
  return response;
});

export const getDirectorAnalysisDataReq = createAsyncThunk('getDirectorAnalysisDataReq', async (req) => {
  const response = await GetDirectorAnalysisData(req);
  return response;
});

export const getDDLEthnicityDataReq = createAsyncThunk('getDDLEthnicityDataReq', async (req) => {
  const response = await GetDDLEthnicityData(req);
  return response;
});

export const getDDLAppointmentTypeDataReq = createAsyncThunk('getDDLAppointmentTypeDataReq', async (req) => {
  const response = await GetDDLAppointmentTypeData(req);
  return response;
});

const lstGenderSelection = [{ label: 'All', value: 0 }];
const ddlGenderOption = [
  { label: 'All', value: 0 },
  { label: 'Male', value: 1 },
  { label: 'Female', value: 2 },
];

const lstBoardTypeSelection = [];
const ddlBoardTypeOption = [
  { label: 'Board of Directors', value: 1 },
  { label: 'Supervisory Board', value: 2 },
  { label: 'Executive Board', value: 3 },
  { label: 'Non Board', value: 4 },
  { label: 'Kansayaku', value: 5 },
];

const lstCurrentAppointment = [{ label: 'Yes', value: 1 }];
const ddlCurrentAppointmentOption = [
  { label: 'Yes', value: 1 },
  { label: 'No', value: 2 },
];

const lstIndependent = [{ label: 'All', value: 0 }];
const ddlIndependentOption = [
  { label: 'Yes', value: 1 },
  { label: 'No', value: 2 },
];

const lstActivistNominee = [];
const lstSpecificIndividual = [];
const lstAppointmentTypeSelection = [];

const remapAppointmentTypeSelectionByLabel = (selection, ddlOptions) => {
  if (!selection || selection.length === 0) {
    return selection;
  }
  if (!ddlOptions || ddlOptions.length === 0) {
    return selection;
  }
  return selection.map((item) => ddlOptions.find((opt) => opt.label === item?.label)).filter(Boolean);
};

const DirectorDataAndAnalyticsToolsSlice = createSlice({
  name: 'directoDataAndAnalytics',
  initialState: {
    ddlGenderOption: ddlGenderOption,
    lstGenderSelection: lstGenderSelection,
    ddlBoardTypeOption: ddlBoardTypeOption,
    lstBoardTypeSelection: lstBoardTypeSelection,
    ddlCurrentAppointmentOption: ddlCurrentAppointmentOption,
    lstCurrentAppointmentSelection: lstCurrentAppointment,
    ddlIndependentOption: ddlIndependentOption,
    lstIndependentSelection: lstIndependent,
    lstActivistNomineeSelection: lstActivistNominee,
    lstSpecificIndividualSelection: lstSpecificIndividual,
    ddlAppointmentTypeOption: [],
    lstAppointmentTypeSelection: lstAppointmentTypeSelection,
    lstEthnicitySelection: [],
    defaultLstEthnicitySelection: [],
    ddlEthnicityOption: [],
    tenureFrom: null,
    tenureTo: null,
    ageFrom: null,
    ageTo: null,
    boardFrom: null,
    boardTo: null,
    lstDirectoAppointmentData: [],
    isLoadingData: undefined,
    isLoadingAnalysis: undefined,
    isRowLimitExceeded: false,
    directorData: true,
    directorAnalysis: false,
    lstDirectorAppointmentAnalysisData0: [],
    lstGenderDiversityOfDirectorAppointment: [],
    lstAvgDirectorAge: [],
    lstAvgDirectorTenure: [],
    lstCompaniesWithFemaleDirector: [],
    lstSectorWithAvgFemaleDirector: [],
    lstMktCapCategoryWithAvgFemaleDirector: [],
    lstMktCapCategoryGenderDiversity: [],
    lstNoOfBoardWithMaleAndFemale: [],
    lstNoOfBoardWithMaleAndFemale_Org: [],
    lstCompaniesWithFemaleDirector_Org: [],
    lstAllData: [],
    lstChartKeys: [],
    yearToData: true,
    currentData: false,
  },
  reducers: {
    handleOnChangeGenderDdl: {
      reducer(state, action) {
        if (action.payload !== null) {
          state.lstGenderSelection = action.payload;
        } else {
          state.lstGenderSelection = lstGenderSelection;
        }
      },
      prepare(e) {
        return {
          payload: e,
        };
      },
    },
    handleOnChangeBoardTypeDdl: {
      reducer(state, action) {
        const selection = action.payload;
        if (selection === null || selection === undefined) {
          state.lstBoardTypeSelection = lstBoardTypeSelection;
        } else if (Array.isArray(selection)) {
          const filteredSelection = selection.filter((x) => x && x.value !== 0);
          state.lstBoardTypeSelection = filteredSelection;
        } else {
          if (selection.value !== 0) {
            state.lstBoardTypeSelection = [selection];
          } else {
            state.lstBoardTypeSelection = [];
          }
        }
      },
      prepare(e) {
        return {
          payload: e,
        };
      },
    },
    handleOnChangeCurrentAppointmentDdl: {
      reducer(state, action) {
        const selection = action.payload;
        if (selection === null || selection === undefined || (Array.isArray(selection) && selection.length === 0)) {
          state.lstCurrentAppointmentSelection = [];
        } else if (Array.isArray(selection)) {
          state.lstCurrentAppointmentSelection = selection.filter((x) => x && x.value !== 0);
        } else {
          state.lstCurrentAppointmentSelection = selection.value !== 0 ? [selection] : [];
        }
      },
      prepare(e) {
        return {
          payload: e,
        };
      },
    },
    handleOnChangeIndependentDdl: {
      reducer(state, action) {
        const selection = action.payload;
        if (selection === null || selection === undefined) {
          state.lstIndependentSelection = lstIndependent;
        } else if (Array.isArray(selection)) {
          const filteredSelection = selection.filter((x) => x && x.value !== 0);
          state.lstIndependentSelection = filteredSelection;
        } else {
          if (selection.value !== 0) {
            state.lstIndependentSelection = [selection];
          } else {
            state.lstIndependentSelection = [];
          }
        }
      },
      prepare(e) {
        return {
          payload: e,
        };
      },
    },
    handleOnChangeActivistNomineeDdl: {
      reducer(state, action) {
        if (action.payload !== null) {
          state.lstActivistNomineeSelection = action.payload;
        } else {
          state.lstActivistNomineeSelection = lstActivistNominee;
        }
      },
      prepare(e) {
        return {
          payload: e,
        };
      },
    },
    handleOnChangeSpecificIndividualDdl: {
      reducer(state, action) {
        if (action.payload !== null) {
          state.lstSpecificIndividualSelection = action.payload;
        } else {
          state.lstSpecificIndividualSelection = lstSpecificIndividual;
        }
      },
      prepare(e) {
        return {
          payload: e,
        };
      },
    },
    handleOnChangeAppointmentDdl: {
      reducer(state, action) {
        if (action.payload !== null) {
          state.lstAppointmentTypeSelection = action.payload;
        } else {
          state.lstAppointmentTypeSelection = lstAppointmentTypeSelection;
        }
      },
      prepare(e) {
        return {
          payload: e,
        };
      },
    },
    handleOnChangeEthnicityDdl: {
      reducer(state, action) {
        const selection = action.payload.lstEthnicitySelection;
        if (selection === null) {
          state.lstEthnicitySelection = current(state).defaultLstEthnicitySelection;
        } else if (selection !== null && selection.length > 1) {
          const arrWithoutAllSelection = selection.filter((x) => x.value !== -1);
          state.lstEthnicitySelection = arrWithoutAllSelection;

          const ddl = current(state).ddlEthnicityOption;
          state.ddlEthnicityOption = ddl.filter((x) => x.value !== -1);
        } else {
          state.lstEthnicitySelection = selection;
        }
      },
      prepare(lstEthnicitySelection) {
        return {
          payload: { lstEthnicitySelection },
        };
      },
    },
    handleOnChangeTenureFrom: {
      reducer(state, action) {
        state.tenureFrom = action.payload !== '' ? action.payload : null;
      },
      prepare(e) {
        return {
          payload: e.target.value,
        };
      },
    },
    handleOnChangeTenureTo: {
      reducer(state, action) {
        state.tenureTo = action.payload !== '' ? action.payload : null;
      },
      prepare(e) {
        return {
          payload: e.target.value,
        };
      },
    },
    handleOnChangeAgeFrom: {
      reducer(state, action) {
        state.ageFrom = action.payload !== '' ? action.payload : null;
      },
      prepare(e) {
        return {
          payload: e.target.value,
        };
      },
    },
    handleOnChangeAgeTo: {
      reducer(state, action) {
        state.ageTo = action.payload !== '' ? action.payload : null;
      },
      prepare(e) {
        return {
          payload: e.target.value,
        };
      },
    },
    handleOnChangeBoardFrom: {
      reducer(state, action) {
        state.boardFrom = action.payload !== '' ? action.payload : null;
      },
      prepare(e) {
        return {
          payload: e.target.value,
        };
      },
    },
    handleOnChangeBoardTo: {
      reducer(state, action) {
        state.boardTo = action.payload !== '' ? action.payload : null;
      },
      prepare(e) {
        return {
          payload: e.target.value,
        };
      },
    },
    handleResetSearch: {
      reducer(state) {
        state.lstGenderDiversityOfDirectorAppointment = [];
        state.isLoadingAnalysis = true;
      },
      prepare(e) {
        return {
          payload: e,
        };
      },
    },
    handleOnChangeOutputFieldChecked: {
      reducer(state, action) {
        if (action.payload === NUMBER_ONE) {
          state.directorData = false;
          state.directorAnalysis = true;
        } else {
          state.directorData = true;
          state.directorAnalysis = false;
        }
      },
      prepare(e) {
        return {
          payload: e,
        };
      },
    },
    handleOnChangeBasedDataChecked: {
      reducer(state, action) {
        if (action.payload === NUMBER_TWO) {
          state.yearToData = false;
          state.currentData = true;
        } else {
          state.yearToData = true;
          state.currentData = false;
        }
      },
      prepare(e) {
        return {
          payload: e,
        };
      },
    },
    handleResetDirectorDataAndAnalyticsTool: {
      reducer(state) {
        state.ddlGenderOption = ddlGenderOption;
        state.lstGenderSelection = lstGenderSelection;
        state.ddlBoardTypeOption = ddlBoardTypeOption;
        state.lstBoardTypeSelection = lstBoardTypeSelection;
        state.ddlCurrentAppointmentOption = ddlCurrentAppointmentOption;
        state.lstCurrentAppointmentSelection = lstCurrentAppointment;
        state.ddlIndependentOption = ddlIndependentOption;
        state.lstIndependentSelection = lstIndependent;
        state.lstActivistNomineeSelection = lstActivistNominee;
        state.lstSpecificIndividualSelection = lstSpecificIndividual;
        state.lstAppointmentTypeSelection = lstAppointmentTypeSelection;
        state.lstEthnicitySelection = [];
        state.defaultLstEthnicitySelection = [];
        state.ddlEthnicityOption = [];
        state.tenureFrom = null;
        state.tenureTo = null;
        state.ageFrom = null;
        state.ageTo = null;
        state.boardFrom = null;
        state.boardTo = null;
        state.lstDirectoAppointmentData = [];
        state.isLoadingData = undefined;
        state.isLoadingAnalysis = undefined;
        state.isRowLimitExceeded = false;
        state.directorData = true;
        state.directorAnalysis = false;
        state.lstDirectorAppointmentAnalysisData = [];
        state.lstGenderDiversityOfDirectorAppointment = [];
        state.lstAvgDirectorAge = [];
        state.lstAvgDirectorTenure = [];
        state.lstCompaniesWithFemaleDirector = [];
        state.lstSectorWithAvgFemaleDirector = [];
        state.lstMktCapCategoryWithAvgFemaleDirector = [];
        state.lstMktCapCategoryGenderDiversity = [];
        state.lstNoOfBoardWithMaleAndFemale = [];
        state.lstNoOfBoardWithMaleAndFemale_Org = [];
        state.lstCompaniesWithFemaleDirector_Org = [];
        state.lstAllData = [];
        state.lstChartKeys = [];
        state.yearToData = true;
        state.currentData = false;
      },
      prepare() {
        return {
          payload: {},
        };
      },
    },
    handleResetResult: {
      reducer(state, action) {
        state.lstDirectoAppointmentData = [];
      },
      prepare(e) {
        return {
          payload: {},
        };
      },
    },
    handleUpdateDataDirectorDataAndAnalyticsToolFilters: {
      reducer(state, action) {
        const data = action.payload.data;

        state.lstGenderSelection = data.lstGenderSelection;
        state.lstBoardTypeSelection = data.lstBoardTypeSelection ?? lstBoardTypeSelection;
        state.lstCurrentAppointmentSelection = data.lstCurrentAppointmentSelection ?? lstCurrentAppointment;
        state.lstIndependentSelection = data.lstIndependentSelection ?? lstIndependent;
        state.lstAppointmentTypeSelection = remapAppointmentTypeSelectionByLabel(
          data.lstAppointmentTypeSelection ?? lstAppointmentTypeSelection,
          current(state).ddlAppointmentTypeOption,
        );
        state.lstActivistNomineeSelection = data.lstActivistNomineeSelection ?? lstActivistNominee;
        state.lstSpecificIndividualSelection = data.lstSpecificIndividualSelection ?? lstSpecificIndividual;
        state.lstEthnicitySelection = data.lstEthnicitySelection;
        state.tenureFrom = data.tenureFrom;
        state.tenureTo = data.tenureTo;
        state.boardFrom = data.boardFrom;
        state.boardTo = data.boardTo;
        state.ageFrom = data.ageFrom;
        state.ageTo = data.ageTo;
        state.directorAnalysis = data.directorAnalysis;
        state.directorData = data.directorData;
      },
      prepare(value) {
        return {
          payload: { data: value },
        };
      },
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getDirectoDataAndAnalyticsDataReq.pending, (state) => {
        state.isLoadingData = true;
      })
      .addCase(getDirectoDataAndAnalyticsDataReq.fulfilled, (state, action) => {
        if (action.payload) {
          state.lstDirectoAppointmentData = action.payload.data ?? [];
          state.isRowLimitExceeded =
            Boolean(action.payload.isOverLimit) || (action.payload.data?.length ?? 0) >= APPOINTMENT_DATA_ROW_LIMIT;
        } else {
          state.lstDirectoAppointmentData = [];
          state.isRowLimitExceeded = false;
        }
        state.isLoadingData = false;
      })
      .addCase(getDirectoDataAndAnalyticsDataReq.rejected, (state) => {
        state.isLoadingData = false;
      })
      .addCase(getDDLEthnicityDataReq.fulfilled, (state, action) => {
        if (action.payload) {
          state.ddlEthnicityOption = action.payload !== undefined ? action.payload.ddlData : [];
          state.lstEthnicitySelection = action.payload !== undefined ? action.payload.ddlAutoSelection : [];
          state.defaultLstEthnicitySelection = action.payload !== undefined ? action.payload.ddlAutoSelection : [];
        }
      })
      .addCase(getDDLAppointmentTypeDataReq.fulfilled, (state, action) => {
        if (action.payload) {
          state.ddlAppointmentTypeOption = action.payload.ddlData ?? [];
          state.lstAppointmentTypeSelection = remapAppointmentTypeSelectionByLabel(
            current(state).lstAppointmentTypeSelection,
            state.ddlAppointmentTypeOption,
          );
        }
      })
      .addCase(getDirectorAnalysisDataReq.pending, (state) => {
        state.isLoadingAnalysis = true;
      })
      .addCase(getDirectorAnalysisDataReq.rejected, (state) => {
        state.isLoadingAnalysis = false;
      })
      .addCase(getDirectorAnalysisDataReq.fulfilled, (state, action) => {
        state.isLoadingAnalysis = false;
        if (action.payload) {
          state.lstGenderDiversityOfDirectorAppointment = [];
          state.lstDirectorAppointmentAnalysisData0 = action.payload.lstDirectorAppointmentAnalysisData0;
          state.lstGenderDiversityOfDirectorAppointment = action.payload.lstGenderDiversityOfDirectorAppointment;
          state.lstAvgDirectorAge = action.payload.lstAvgDirectorAge;
          state.lstAvgDirectorTenure = action.payload.lstAvgDirectorTenure;
          state.lstCompaniesWithFemaleDirector = action.payload.lstCompaniesWithFemaleDirector;
          state.lstSectorWithAvgFemaleDirector = action.payload.lstSectorWithAvgFemaleDirector;
          state.lstMktCapCategoryWithAvgFemaleDirector = action.payload.lstMktCapCategoryWithAvgFemaleDirector;
          state.lstMktCapCategoryGenderDiversity = action.payload.lstMktCapCategoryGenderDiversity;
          state.lstNoOfBoardWithMaleAndFemale = action.payload.lstNoOfBoardWithMaleAndFemale;
          state.lstNoOfBoardWithMaleAndFemale_Org = action.payload.lstNoOfBoardWithMaleAndFemale_Org;
          state.lstCompaniesWithFemaleDirector_Org = action.payload.lstCompaniesWithFemaleDirector_Org;
          state.lstAllData = action.payload.data;
          state.lstChartKeys = action.payload.keyData;
        }
      });
  },
});

export const {
  handleOnChangeGenderDdl,
  handleOnChangeBoardTypeDdl,
  handleOnChangeCurrentAppointmentDdl,
  handleOnChangeIndependentDdl,
  handleOnChangeActivistNomineeDdl,
  handleOnChangeSpecificIndividualDdl,
  handleOnChangeAppointmentDdl,
  handleOnChangeEthnicityDdl,
  handleOnChangeTenureFrom,
  handleOnChangeTenureTo,
  handleOnChangeAgeFrom,
  handleOnChangeAgeTo,
  handleOnChangeBoardFrom,
  handleOnChangeBoardTo,
  handleOnChangeOutputFieldChecked,
  handleOnChangeBasedDataChecked,
  handleResetSearch,
  handleResetDirectorDataAndAnalyticsTool,
  handleResetResult,
  handleUpdateDataDirectorDataAndAnalyticsToolFilters,
} = DirectorDataAndAnalyticsToolsSlice.actions;
export default DirectorDataAndAnalyticsToolsSlice.reducer;
